import { getMesObsequesData, saveMesObsequesData, uploadFile } from '../api/api';

// SET_CEREMONY
export const setCeremony = (ceremonyData) => ({
    type: 'SET_CEREMONY',
    data: ceremonyData
});


export const starSetCeremony = (ceremonyData = {}) => {
    return (dispatch) => {
        dispatch(setCeremony(ceremonyData))
    }
};

// SET_CONSERVATION_CARE
export const setConservationCare = (conservationCare) => ({
    type: 'SET_CONSERVATION_CARE',
    data: conservationCare
});


export const starSetConservationCare = (conservationCare = {}) => {
    return (dispatch) => {
        dispatch(setConservationCare(conservationCare))
    }
};

// SET_OTHER_PROVISION
export const setOtherProvision = (otherProvision) => ({
    type: 'SET_OTHER_PROVISION',
    data: otherProvision
});


export const starSetOtherProvision = (otherProvision = {}) => {
    return (dispatch) => {
        dispatch(setOtherProvision(otherProvision))
    }
};

// Get Mes Obseques information
export const starGetMesObsequesData = (idBenef = '', idPartner = '') => {
    return () => {
        return getMesObsequesData(idBenef, idPartner);
    }
};

export const starSetMesObsequesData = (serverData = {}, idPartner = '') => {
    return () => {
        return Promise.all(
            [
                saveMesObsequesData(serverData, idPartner)
                , serverData.ceremonie.file && uploadFile(serverData.ceremonie.file, idPartner)
                , serverData.autres.file &&  uploadFile(serverData.autres.file, idPartner)
            ]
        )
    }
}


// WEBPACK FOOTER //
// ./src/actions/funeral.js